import React, { useState, useEffect } from 'react'
import { IconPencil } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TextArea } from '@/components/forms/TextArea'

/**
 * Editable description component with auto-resizing textarea
 */
export const EditableDescription = ({ value, onEdit, editable = false }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editedValue, setEditedValue] = useState(value || '')

  // Sync local state when external value changes
  useEffect(() => {
    setEditedValue(value || '')
  }, [value])

  const handleSave = async (event) => {
    event.stopPropagation()
    if (onEdit) {
      await onEdit(editedValue)
    }
    setIsEditing(false)
  }

  const handleCancel = (event) => {
    event.stopPropagation()
    setEditedValue(value || '')
    setIsEditing(false)
  }

  if (isEditing) {
    return (
      <div className="description-edit" onClick={(event) => event.stopPropagation()}>
        <TextArea
          autoResize
          value={editedValue}
          onChange={(event) => setEditedValue(event.target.value)}
          placeholder="Add a description..."
          autoFocus
        />
        <div className="description-edit__buttons">
          <Button xs primary onClick={handleSave}>
            Save
          </Button>
          <Button xs onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="description-display">
      {editable && (
        <Button
          basic
          xs
          square
          onClick={(event) => {
            event.stopPropagation()
            setIsEditing(true)
          }}
          className="edit-description-button"
          title="Edit description"
        >
          <IconPencil />
        </Button>
      )}
      <span className="muted-text small">{value || 'No description'}</span>
    </div>
  )
}
